import { useMemo } from "react";
import { catalogueEntryOf } from "../../catalogue/types";
import { useCatalogue, useLayers } from "../hooks";

export type AttributionProps = { className?: string; extra?: string[] };

export function attributionTexts(entries: { attribution: string | null; tile: { attribution: string } | null; special: { attribution: string } | null }[]): string[] {
  const seen = new Set<string>();
  const result: string[] = [];

  for (const entry of entries) {
    const text = (entry.attribution ?? entry.tile?.attribution ?? entry.special?.attribution ?? "").trim();

    if (text.length === 0 || seen.has(text)) continue;

    seen.add(text);
    result.push(text);
  }

  return result;
}

export function Attribution({ className, extra = [] }: AttributionProps) {
  const catalogue = useCatalogue();
  const { list } = useLayers();

  const texts = useMemo(() => {
    const entries = list.filter(a => a.selected).map(a => catalogueEntryOf(catalogue, a)).filter(a => a !== null);

    return [...attributionTexts(entries), ...extra];
  }, [catalogue, list, extra]);

  if (texts.length === 0) return null;

  return <div className={["fxmap-attribution", "fxmap-glass", className ?? ""].filter(Boolean).join(" ")} data-fxmap="attribution" dangerouslySetInnerHTML={{ __html: texts.join(" | ") }} />;
}
